export default __webpack_public_path__ + "static/media/chevron-back.b2423ac3.svg";